import React from "react";
import MaskedInput from "react-text-mask";

export const cpfMask = [
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, "-",
  /\d/, /\d/,
];

export const cnpjMask = [
  /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, "/",
  /\d/, /\d/, /\d/, /\d/, "-",
  /\d/, /\d/,
];

export const cepMask = [
  /\d/, /\d/, /\d/, /\d/, /\d/,
  "-", /\d/, /\d/, /\d/,
];

export const flexiblePhoneMask = (rawValue = "") => {
  const digits = String(rawValue).replace(/\D/g, "");
  const hasNinthDigit = digits.length > 10;

  return hasNinthDigit
    ? [
        "(", /\d/, /\d/, ")", " ",
        /\d/, " ", /\d/, /\d/, /\d/, /\d/,
        "-", /\d/, /\d/, /\d/, /\d/,
      ]
    : [
        "(", /\d/, /\d/, ")", " ",
        /\d/, /\d/, /\d/, /\d/,
        "-", /\d/, /\d/, /\d/, /\d/,
      ];
};

export const phoneMask = flexiblePhoneMask;

export const TextMaskCustom = React.forwardRef(function TextMaskCustom(
  props,
  ref,
) {
  const { mask, ...other } = props;

  return (
    <MaskedInput
      {...other}
      guide={false}
      mask={mask}
      ref={(maskedInputRef) => {
        if (!maskedInputRef) return;

        const inputElement = maskedInputRef.inputElement;

        if (typeof ref === "function") {
          ref(inputElement);
          return;
        }

        if (ref) {
          ref.current = inputElement;
        }
      }}
    />
  );
});
